import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useApprovalsBell } from "@/hooks/useApprovalsBell";
import { formatDateTime } from "@/lib/datetime";
import { formatAutoSummary } from "@/lib/approvals-summary";

const VISIBLE = 3;

export function PendingApprovalsWidget(): React.ReactElement {
  const { t, i18n } = useTranslation();
  const { data, isLoading } = useApprovalsBell();
  const cards = data.latest.slice(0, VISIBLE);

  return (
    <Card data-testid="widget-pending-approvals">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">
          {t("home.widgets.pendingApprovals.title")}
        </CardTitle>
        <span className="text-2xl font-semibold tabular-nums">{data.count}</span>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <p className="text-muted-foreground text-sm">{t("common.loading")}</p>
        ) : cards.length === 0 ? (
          <p className="text-muted-foreground text-sm">
            {t("home.widgets.pendingApprovals.empty")}
          </p>
        ) : (
          <ul className="space-y-2">
            {cards.map((card) => (
              <li key={card.simulation_id} className="border-border border-b pb-2 last:border-0">
                <Link
                  to="/approvals/$simulationId"
                  params={{ simulationId: card.simulation_id }}
                  data-testid={`widget-pending-card-${card.simulation_id}`}
                  className="hover:bg-accent block rounded px-1.5 py-1"
                >
                  <p className="text-sm font-medium">{formatAutoSummary(card, t)}</p>
                  <p className="text-muted-foreground text-xs">
                    {t("home.widgets.pendingApprovals.expires", {
                      when: formatDateTime(card.expires_at, i18n.resolvedLanguage),
                    })}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
